import React, { useCallback, useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { jv } from './api';
import { ActionSheet } from './ActionSheet';

// Occasional "Hey Emmanuel, I noticed…" nudge. The server decides (urgent only, daily cap, working hours, never the same issue twice).
export const JarvisPopup = () => {
  const { token } = useAuth();
  const [p, setP] = useState(null);
  const [sheet, setSheet] = useState(false);
  const check = useCallback(() => { if (token && !document.hidden) jv.popup(token).then((d) => d.popup && setP(d)).catch(() => {}); }, [token]);
  useEffect(() => {
    if (!token) return undefined;
    const first = setTimeout(check, 15000); const t = setInterval(check, 120000);
    return () => { clearTimeout(first); clearInterval(t); };
  }, [token, check]);
  if (!p) return null;
  const close = () => setP(null);
  return (
    <>
      {!sheet && (
        <div className="fixed bottom-6 left-6 lg:left-[240px] z-[70] w-[min(380px,calc(100vw-48px))] cp-dark animate-in fade-in slide-in-from-bottom-4 rounded-2xl bg-[#0B1640] p-4 text-white shadow-2xl ring-1 ring-white/10" role="status" data-testid="jarvis-popup">
          <div className="flex items-start gap-3">
            <span className="relative mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-gradient-to-br from-[#2347FF] to-[#3CC8FF]"><span className="absolute inset-0 animate-ping rounded-full bg-[#3CC8FF]/30" /><span className="text-[11px] font-black">JV</span></span>
            <div className="min-w-0 flex-1">
              <div className="text-[10px] font-bold uppercase tracking-widest text-[#A9B4DA]">Jarvis · Chief of Staff</div>
              <p className="mt-1 text-sm leading-relaxed" data-testid="jarvis-popup-text"><b>{p.greeting}</b> {p.popup.popup}</p>
              <div className="mt-3 flex gap-2">
                <button type="button" className="rounded-lg bg-white px-3 py-1.5 text-xs font-bold text-[#0B1640] transition-colors hover:bg-[#ECF0FF]" onClick={() => setSheet(true)} data-testid="jarvis-popup-review">Take a look</button>
                <button type="button" className="rounded-lg px-3 py-1.5 text-xs font-semibold text-[#A9B4DA] transition-colors hover:bg-white/10" onClick={() => { jv.snooze(token, p.popup.id).catch(() => {}); close(); }} data-testid="jarvis-popup-later">Remind me tomorrow</button>
              </div>
            </div>
            <button type="button" aria-label="Close" className="rounded-md p-1 text-[#A9B4DA] hover:bg-white/10" onClick={close} data-testid="jarvis-popup-close"><X className="h-4 w-4" /></button>
          </div>
        </div>
      )}
      <ActionSheet token={token} insight={p.popup} open={sheet} onClose={() => { setSheet(false); close(); }} onChanged={() => window.dispatchEvent(new Event('jarvis:changed'))} />
    </>
  );
};

export default JarvisPopup;
